import React, {Component, PropTypes} from 'react'
import OutsideScriptManager from '../OutsideScriptManager'
import Analytics from '../Analytics'

const size = function(s){
  if(s === '728x90')
    return [[728,90]]
  if(s === '320x50')
    return [[320,50]]
  else
    throw new Error('unknown ad size')

}

class ResponsiveAdContainer extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.configuration = {}
    this.uid = 'gnm-responsive-ad-container-' + Math.round(Math.random()*100000,0)

  }

  componentDidMount(){
  //  OutsideScriptManager.load('gpt');
    try{
      this.configure()
      this.chooseAdToShow()
    }catch(e){
      e.message += ' in ResponsiveAdContainer '
      Analytics.reportError(e)
    }

  }

  chooseAdToShow(){
    //OutsideScriptManager.load('gpt').then(()=>{

      window.gptadslots = window.gptadslots || [];
      window.googletag = window.googletag || {
        cmd: []
      };

      if(window.innerWidth <= 768)
        this.createAd(this.configuration.xs)
      else if(window.innerWidth <= 992)
        this.createAd(this.configuration.sm)
      else if(window.innerWidth <= 1200)
        this.createAd(this.configuration.md)
      else if(window.innerWidth <= 1470)
        this.createAd(this.configuration.lg)
      else
        this.createAd(this.configuration.xl)
  //  })
  }

  createAd = (config)=>{
    if(!config.show)
      return
    googletag.cmd.push(()=>{
      let contentClassification = window.franklyDataLayer[0].content_classification.replace(/[ ?/]/gi, '').toLowerCase();
      gptadslots.push(googletag.defineSlot('/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification, config.size, this.uid)
      .addService(googletag.pubads()));
        console.log('ResponsiveAdContainer used %s','/43459271/loc-desktop/'+this.props.affiliate+ '/web/' + contentClassification)
      googletag.pubads().setTargeting('wnsz',[config.wnsz.toFixed(0)]).enableSingleRequest();
      googletag.enableServices();
    });

    window.googletag.cmd.push(()=>{
      googletag.display(this.uid)
    }); //large header ad
  }

  configure = ()=>{
    this.configuration ={
      xs: {
        show: this.props.xsShow,
        wnsz: this.props.xsTargeting,
        size: size(this.props.xsSize)
      },
      sm: {
        show: this.props.smShow,
        wnsz: this.props.smTargeting,
        size: size(this.props.smSize)
      },
      md: {
        show: this.props.mdShow,
        wnsz: this.props.mdTargeting,
        size: size(this.props.mdSize)
      },
      lg: {
        show: this.props.lgShow,
        wnsz: this.props.lgTargeting,
        size: size(this.props.lgSize)
      },
      xl: {
        show: this.props.xlShow,
        wnsz: this.props.xlTargeting,
        size: size(this.props.xlSize)
      }
    }
  }




  render() { // REQUIRED
    return (
      <div className='gnm-responsive-ad-container'>
        <div id={this.uid} className='ad'></div>
      </div>
    )
  }
}

export default ResponsiveAdContainer



// WEBPACK FOOTER //
// ./app/components/custom/ssr/ResponsiveAdContainer/index.js